import React from "react";
import cx from "classnames";
import { useField } from "formik";
import InputField from "./InputField";

const Textbox = ({ className, containerClass, ...props }) => {
  const [field, meta] = useField(props);

  return (
    <InputField className={containerClass} {...{ ...props, meta }}>
      <input
        className={cx(
          "form-control gkit-input-md",
          className,
          meta && meta.touched && meta.error && "is-invalid"
        )}
        type="text"
        {...field}
        {...props}
      />
    </InputField>
  );
};

export default Textbox;
